var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PaletteChip,{attrs:{"id_palette":_setup.compIdPalette}},[_vm._v(_vm._s(_setup.compName))])
}
var staticRenderFns = []

export { render, staticRenderFns }